import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { FloatingModal } from '../../../components/Modal';
import styles from './security.scss';

const propTypes = {
  show: PropTypes.bool,
  id: PropTypes.number,

  onDelete: PropTypes.func,
  onModalClose: PropTypes.func,
};

class ConfirmModal extends PureComponent {
  render() {
    const {
      show, id,
    } = this.props;

    return (
      <FloatingModal
        isOpen={show}
        onRequestClose={() => this.props.onModalClose()}
        action={{
          onClick: () => this.props.onDelete(id),
          text: 'Delete',
        }}
        buttonText="Cancel"
      >
        <div className={styles.modal}>
          <div className={styles.modalTitle}>Rename</div>
          <div className={styles.modalMessage}>
            Are you sure you want to delete this secret?
          </div>
        </div>
      </FloatingModal>
    );
  }
}

ConfirmModal.propTypes = propTypes;

export default ConfirmModal;
